import fetch from '../../../api/fetch';
import { enqueueSnackbar } from '../snackbar';
import { REDUX_ACTIONS } from '../../../shared/config/constants';

export const epicorSyncMobileDevices = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.EPICOR_SYNC_MOBILE_DATA_LOADING,
    payload: {
      message: 'Please wait...',
    },
  });

  const body = {
    url: '/sync',
    type: 'POST',
  };
  return fetch
    .post('epicorProxy/epicorProxyPost', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((res) => {
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SYNC_MOBILE_DATA_IDLE,
        payload: {
          message: res.data.message,
        },
      });
    })
    .catch(async (error) => {
      dispatch(
        enqueueSnackbar(
          error.message || 'Error syncing mobile devices',
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SYNC_MOBILE_DATA_ERROR,
        payload: {
          message: error.message || 'Error syncing mobile devices',
        },
      });
    });
};
